<div class="aca-admin aca-cm">
  <aca-page-header icon="drive_file_move" [title]="'DMS.COPY_MOVE.B2B3FF' | translate" [subtitle]="'DMS.UI.137CC0' | translate" />

  <!-- ── source breadcrumb ──────────────────────────────────────────────── -->
  <nav class="aca-cm__crumbs" [attr.aria-label]="'DMS.COPY_MOVE.1450F6' | translate">
    <button
      type="button"
      class="aca-cm__crumb"
      (click)="loadSource('-root-')"
      [matTooltip]="'DMS.COPY_MOVE.503968' | translate"
      [attr.aria-label]="'DMS.COPY_MOVE.503968' | translate"
    >
      <mat-icon>home</mat-icon>
    </button>
    <ng-container *ngFor="let crumb of sourceInfo()?.crumbs ?? []; trackBy: trackByCrumb">
      <mat-icon class="aca-cm__crumbsep">chevron_right</mat-icon>
      <button type="button" class="aca-cm__crumb" (click)="loadSource(crumb.id)">{{ crumb.name }}</button>
    </ng-container>
  </nav>

  <div class="aca-cm__workspace">
    <!-- ── left: source folder information ──────────────────────────────── -->
    <aside class="aca-cm__panel aca-cm__panel--info">
      <h2 class="aca-cm__paneltitle">{{ 'DMS.COPY_MOVE.488507' | translate }}</h2>

      <dl class="aca-cm__props" *ngIf="sourceInfo() as info">
        <dt>{{ 'DMS.COPY_MOVE.2E9D2C' | translate }}</dt>
        <dd>{{ info.name }}</dd>

        <dt>{{ 'DMS.COPY_MOVE.9CFD2F' | translate }}</dt>
        <dd>{{ info.createdByName || '—' }}</dd>

        <dt>{{ 'DMS.COPY_MOVE.5B68F3' | translate }}</dt>
        <dd>{{ info.createdAt | acaDate: 'd MMM y HH:mm' }}</dd>

        <dt>{{ 'DMS.COPY_MOVE.E38F3B' | translate }}</dt>
        <dd>{{ info.modifiedAt | acaDate: 'd MMM y HH:mm' }}</dd>

        <dt>{{ 'DMS.COPY_MOVE.20DE02' | translate }}</dt>
        <dd>{{ sourceTotal() | number }} {{ 'DMS.UI.4514CB' | translate }}</dd>
      </dl>

      <p class="aca-cm__hint">{{ 'DMS.COPY_MOVE.31440C' | translate }}</p>
    </aside>

    <!-- ── middle: source contents ──────────────────────────────────────── -->
    <section class="aca-cm__panel aca-cm__panel--list">
      <header class="aca-cm__panelhead">
        <h2 class="aca-cm__paneltitle">{{ 'DMS.COPY_MOVE.5764FA' | translate }}</h2>
        <span class="aca-cm__selected" *ngIf="selectedCount()">
          {{ 'DMS.UI.7B772E' | translate }} {{ selectedCount() }} {{ 'DMS.UI.4514CB' | translate }}
          <button type="button" class="aca-cm__link" (click)="clearSelection()">{{ 'DMS.COPY_MOVE.6DACC8' | translate }}</button>
        </span>
      </header>

      <mat-progress-bar mode="indeterminate" *ngIf="sourceLoading()" />

      <aca-page-state
        *ngIf="sourceFailed()"
        state="error"
        [title]="'DMS.COPY_MOVE.0C462A' | translate"
        [message]="sourceFailed()"
        [actionLabel]="'DMS.UI.324E7E' | translate"
        (action)="loadSource(sourceId)"
      />

      <aca-page-state
        *ngIf="!sourceFailed() && !sourceLoading() && !sourceNodes().length"
        state="empty"
        icon="folder_open"
        [title]="'DMS.COPY_MOVE.72A9BF' | translate"
        [message]="'DMS.UI.3E20D5' | translate"
      />

      <div class="aca-cm__tablewrap" *ngIf="!sourceFailed() && sourceNodes().length">
        <table class="aca-cm__table">
          <thead>
            <tr>
              <th class="aca-cm__th aca-cm__th--check">
                <mat-checkbox
                  [checked]="allSelected()"
                  [indeterminate]="someSelected()"
                  (change)="toggleAll()"
                  [attr.aria-label]="'DMS.COPY_MOVE.D92662' | translate"
                />
              </th>
              <th class="aca-cm__th aca-cm__th--name">{{ 'DMS.COPY_MOVE.0B1FCF' | translate }}</th>
              <th class="aca-cm__th">{{ 'DMS.COPY_MOVE.AEABC8' | translate }}</th>
              <th class="aca-cm__th">{{ 'DMS.COPY_MOVE.E38F3B' | translate }}</th>
              <th class="aca-cm__th">{{ 'DMS.COPY_MOVE.6F4212' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr
              class="aca-cm__row"
              *ngFor="let node of sourceNodes(); trackBy: trackById"
              [class.aca-cm__row--on]="isSelected(node)"
              (dblclick)="openSource(node)"
            >
              <td class="aca-cm__td aca-cm__td--check">
                <mat-checkbox
                  [checked]="isSelected(node)"
                  (change)="toggle(node)"
                  [attr.aria-label]="('DMS.UI.B56AEE' | translate) + node.name"
                  [attr.data-automation-id]="'dms-cm-select-' + node.name"
                />
              </td>
              <td class="aca-cm__td aca-cm__td--name">
                <span class="aca-cm__badge" [ngClass]="badgeClass(node)">
                  <mat-icon *ngIf="node.isFolder">folder</mat-icon>
                  <ng-container *ngIf="!node.isFolder">{{ badge(node) }}</ng-container>
                </span>
                <button
                  type="button"
                  class="aca-cm__name"
                  [attr.data-automation-id]="'dms-cm-open-' + node.name"
                  (click)="openSource(node)"
                  [matTooltip]="node.isFolder ? ('DMS.UI.13CA83' | translate) : node.name"
                >
                  {{ node.name }}
                </button>
              </td>
              <td class="aca-cm__td">{{ (node.isFolder ? 'DMS.UI.848311' : label(node.documentType) || 'DMS.UI.D997F7') | translate }}</td>
              <td class="aca-cm__td">{{ node.modifiedAt | acaDate: 'd MMM y HH:mm' }}</td>
              <td class="aca-cm__td">{{ formatSize(node) }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <footer class="aca-cm__panelfoot" *ngIf="sourceNodes().length">
        {{ 'DMS.UI.1D31FB' | translate }} {{ sourceNodes().length | number }} {{ 'DMS.UI.F2DB2C' | translate }} {{ sourceTotal() | number }}
        {{ 'DMS.UI.4514CB' | translate }}
      </footer>
    </section>

    <!-- ── right: destination ───────────────────────────────────────────── -->
    <aside class="aca-cm__panel aca-cm__panel--target">
      <h2 class="aca-cm__paneltitle">{{ 'DMS.COPY_MOVE.7C0D13' | translate }}</h2>

      <div class="aca-cm__tabs" role="tablist">
        <button
          type="button"
          role="tab"
          class="aca-cm__tab"
          [class.aca-cm__tab--on]="operation === 'copy'"
          [attr.aria-selected]="operation === 'copy'"
          data-automation-id="dms-cm-mode-copy"
          (click)="setOperation('copy')"
        >
          {{ 'DMS.COPY_MOVE.A8D12C' | translate }}
        </button>
        <button
          type="button"
          role="tab"
          class="aca-cm__tab"
          [class.aca-cm__tab--on]="operation === 'move'"
          [attr.aria-selected]="operation === 'move'"
          data-automation-id="dms-cm-mode-move"
          (click)="setOperation('move')"
        >
          {{ 'DMS.COPY_MOVE.EA7F9F' | translate }}
        </button>
      </div>

      <nav class="aca-cm__crumbs aca-cm__crumbs--target" [attr.aria-label]="'DMS.COPY_MOVE.79841E' | translate">
        <button
          type="button"
          class="aca-cm__crumb"
          (click)="loadTarget('-root-')"
          [matTooltip]="'DMS.COPY_MOVE.503968' | translate"
          [attr.aria-label]="'DMS.COPY_MOVE.503968' | translate"
        >
          <mat-icon>home</mat-icon>
        </button>
        <ng-container *ngFor="let crumb of targetInfo()?.crumbs ?? []; trackBy: trackByCrumb">
          <mat-icon class="aca-cm__crumbsep">chevron_right</mat-icon>
          <button type="button" class="aca-cm__crumb" (click)="targetUp(crumb.id)">{{ crumb.name }}</button>
        </ng-container>
      </nav>

      <mat-progress-bar mode="indeterminate" *ngIf="targetLoading()" />

      <ul class="aca-cm__tree">
        <li *ngFor="let folder of targetNodes(); trackBy: trackById">
          <button
            type="button"
            class="aca-cm__treeitem"
            [attr.data-automation-id]="'dms-cm-target-' + folder.name"
            (click)="loadTarget(folder.id)"
            [disabled]="!folder.canCreate"
          >
            <mat-icon class="aca-cm__treeicon">folder</mat-icon>
            <span class="aca-cm__treename">{{ folder.name }}</span>
            <mat-icon class="aca-cm__treego">chevron_right</mat-icon>
          </button>
        </li>
        <li class="aca-cm__treeempty" *ngIf="!targetLoading() && !targetNodes().length">{{ 'DMS.COPY_MOVE.CCFC3F' | translate }}</li>
      </ul>

      <button type="button" class="aca-cm__newfolder" (click)="createTargetFolder()" [disabled]="!targetInfo() || working()">
        <mat-icon>create_new_folder</mat-icon>{{ 'DMS.COPY_MOVE.864C3D' | translate }}
      </button>

      <dl class="aca-cm__props aca-cm__props--target">
        <dt>{{ 'DMS.COPY_MOVE.EBF10F' | translate }}</dt>
        <dd>{{ targetPath() }}</dd>

        <dt>{{ 'DMS.COPY_MOVE.93458E' | translate }}</dt>
        <dd>{{ selectedCount() }} {{ 'DMS.UI.4514CB' | translate }}</dd>

        <dt>{{ 'DMS.COPY_MOVE.BA5189' | translate }}</dt>
        <dd>{{ operation === 'copy' ? ('DMS.UI.C480AD' | translate) : ('DMS.UI.3BBE19' | translate) }}</dd>
      </dl>

      <p class="aca-cm__warn" *ngIf="targetId === sourceId">{{ 'DMS.COPY_MOVE.1F60FA' | translate }}</p>

      <button type="button" class="aca-cm__paste" data-automation-id="dms-cm-paste" (click)="paste()" [disabled]="!canPaste()">
        <mat-icon>{{ operation === 'copy' ? 'content_copy' : 'drive_file_move' }}</mat-icon>
        {{
          working()
            ? ('DMS.UI.40E75C' | translate)
            : ('DMS.UI.D646DE' | translate) + (operation === 'copy' ? ('DMS.UI.C480AD' | translate) : ('DMS.UI.3BBE19' | translate)) + ')'
        }}
      </button>
    </aside>
  </div>
</div>
